var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueStarr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8235 4.8415L13.9985 7.1915C14.1568 7.5165 14.5818 7.82483 14.9402 7.89149L17.0652 8.24149C18.4235 8.46649 18.7402 9.44983 17.7652 10.4332L16.1068 12.0915C15.8318 12.3665 15.6735 12.9082 15.7652 13.2998L16.2402 15.3498C16.6152 16.9665 15.7485 17.5998 14.3235 16.7498L12.3318 15.5665C11.9735 15.3498 11.3735 15.3498 11.0152 15.5665L9.02348 16.7498C7.59848 17.5915 6.73183 16.9665 7.10683 15.3498L7.58183 13.2998C7.6735 12.9165 7.51516 12.3748 7.24016 12.0915L5.58184 10.4332C4.60684 9.45816 4.9235 8.47483 6.28183 8.24149L8.40682 7.89149C8.76516 7.83316 9.19016 7.5165 9.34849 7.1915L10.5235 4.8415C11.1485 3.5665 12.1818 3.5665 12.8235 4.8415Z",
    stroke: "#2C4657",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 4.6665H1.66797",
    stroke: "#2C4657",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 16.3335H1.66797",
    stroke: "#2C4657",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5013 10.5H1.66797",
    stroke: "#2C4657",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStarr);
export default __webpack_public_path__ + "static/media/blue-starr.0ff32f43eb29b9d789601b88a0e8adfe.svg";
export { ForwardRef as ReactComponent };